<template>
    <div>
        <LiveDesktopMode
            :courseToken="courseToken"
            :userInfo="userInfo"
            :goodsCourseInfo="goodsCourseInfo"
            :courseNo="courseNo"
            :courseId="courseId"
            :liveCoursePackage="liveCoursePackage"
            :envWebview="envWebview"
            v-if="isShowLive && liveModel === 'desktop'"
            @showEvaluate="onShowEvaluate"
        />

        <!-- 直播答疑课程领取 -->
        <PaidCourseReceive :courseInfo="liveCoursePackage" v-if="isShowPaidCourseReceive" @authSuccess="authSuccess" />
        <AuthTel v-if="isShowAuthTel" @authSuccess="onTelAuthSuccess" />
        <Watermark v-if="userInfo" />
        <Evaluate
            :courseInfo="goodsCourseInfo"
            v-show="isShowEvaluate"
            :isShowEvaluate="isShowEvaluate"
            :mobile="true"
        />

        <!-- 非微信环境登录 -->
        <LoginDialogM v-if="isShowLoginDialogM" @authSuccess="onLoginSuccess" />
        <Officialaccount ref="officialaccount" />
    </div>
</template>
<script>
import { getUserInfo, setUserInfo } from '@/utils/login.js'
import { receiveCourse, getCourseLiveInfo, getPaidStatus, userShareInvited } from '@/utils/api.js'
import { getSubscribeStatus, loginByAuthTicket, getWxJsapiTicket } from '@/utils/api.js'
import { isCurrentEnv, urlQuery, randomString, isPekiApp, isPekiApplet } from '@/utils/utils.js'
import sha1 from '@/utils/sha1.js'
import LiveDesktopMode from './live-m.vue'
import Officialaccount from '@/components/Officialaccount'
import PaidCourseReceive from '@/components/PaidCourseReceive'
import AuthTel from '@/components/AuthTel'
import Watermark from '@/components/Watermark'
import Evaluate from '@/components/Evaluate'
import LoginDialogM from '@/components/LoginDialogM'
import { getAuthTicket, setAppTitle } from '@/utils/jsbrage.js'
const wxSdk = require('weixin-js-sdk')

export default {
    name: 'live-main',
    components: { LiveDesktopMode, PaidCourseReceive, AuthTel, Watermark, Evaluate, LoginDialogM, Officialaccount },
    data() {
        return {
            userInfo: null,
            goodsCourseInfo: null,
            liveCoursePackage: null,
            courseNo: '',
            courseId: '',
            isShowAuthTel: false,
            isShowPaidCourseReceive: false,

            liveModel: 'desktop',
            isShowLive: false,
            isShowEvaluate: false,
            isShowLoginDialogM: false,

            envWebview: '',
        }
    },
    created() {
        window.wxSdk = wxSdk
        this.options = urlQuery()
        this.userInfo = getUserInfo()
        this.courseToken = this.options.courseToken
        // APP webview 登录
        if (isPekiApp()) {
            this.envWebview = 'app'
            getAuthTicket((tpTicket) => {
                loginByAuthTicket({ authTicket: tpTicket }).then((res) => {
                    setUserInfo(res.data)
                    this.userInfo = res.data
                    this.$nextTick(() => {
                        this.getPaidStatusApi()
                    })
                })
            })
            return
        }
        // 小程序 webview 登录
        if (isPekiApplet()) {
            this.envWebview = 'applet'
            loginByAuthTicket({ authTicket: this.options.tpTicket, appId: window.WX_APPID }).then((res) => {
                setUserInfo(res.data)
                this.userInfo = res.data
                this.$nextTick(() => {
                    this.getPaidStatusApi()
                })
            })
            return
        }

        const state = isCurrentEnv('Mobile', 'live-m', 'live-pc')
        if (state) return

        if (!this.courseToken) {
            return this.$toast({ duration: 0, message: '暂无直播课程', overlay: true })
        } else if (this.courseToken && this.userInfo) {
            this.getPaidStatusApi()
        } else {
            this.isShowLoginDialogM = true
        }
    },
    methods: {
        onTelAuthSuccess(userInfo) {
            this.isShowAuthTel = false
            this.isShowLoginDialogM = false
            this.userInfo = userInfo
            this.receiveCourseApi()
        },
        onLoginSuccess(userInfo) {
            setUserInfo(userInfo)
            this.userInfo = userInfo
            this.getPaidStatusApi()
        },
        authSuccess() {
            this.isShowPaidCourseReceive = false
            this.isShowLive = true
            this.getSubscribeStatusApi()
        },
        getPaidStatusApi() {
            getCourseLiveInfo({
                courseToken: this.courseToken,
            }).then((course) => {
                this.goodsCourseInfo = course.data.course
                let packageNo, packageType
                try {
                    packageNo = course.data.coursePackage.packageNo
                    packageType = course.data.coursePackage.type
                    document.title = course.data.course.title
                    this.packageNo = course.data.coursePackage.packageNo
                    this.liveCoursePackage = course.data.coursePackage
                    this.courseNo = course.data.course.courseNo
                    this.courseId = course.data.course.id
                    this.$forceUpdate()
                    if (course.data.course.liveModel) this.liveModel = course.data.course.liveModel
                    if (isPekiApp()) {
                        setAppTitle(document.title)
                    }
                } catch (error) {
                    this.$toast('获取课程信息失败')
                    return
                }

                if (course.data.audition && course.data.audition.validFlag) {
                    this.authSuccess()
                } else {
                    getPaidStatus({
                        packageNo: packageNo,
                        userId: this.userInfo.id,
                    }).then((res) => {
                        if (res.data) {
                            if (res.data.status) {
                                this.authSuccess()
                            } else if (packageType === 1) {
                                // 公开课且配置 收集手机号
                                if (this.liveCoursePackage.type === 1) {
                                    const collects = this.liveCoursePackage.collects
                                    // 公开课 未报名&没有手机号 且collects 含有tel
                                    if (!this.userInfo.telNo && collects && collects.includes('tel')) {
                                        this.isShowAuthTel = true
                                    } else {
                                        // 如果用户未报名则直接报名 且课程为公开课
                                        this.receiveCourseApi()
                                    }
                                    // 直播答疑课 密码报名
                                } else {
                                    this.receiveCourseApi()
                                }
                            } else if ([2, 3].includes(packageType)) {
                                this.$toast({ duration: 0, message: '付费课程，暂无观看权限', overlay: true })
                            } else if (packageType === 4) {
                                // 直播答疑课
                                this.isShowPaidCourseReceive = true
                                this.$forceUpdate()
                            }
                        }
                    })
                }
                this.userShareInvitedApi()
                this.wxSdkReady(course.data.course)
            })
        },
        receiveCourseApi() {
            const params = {
                packageNo: this.packageNo,
                userId: this.userInfo.id,
            }
            if (this.options.sn) {
                params.sourceFrom = this.options.sn
                params.sourceType = 2
                if (this.options.sn === 'invite') {
                    params.sourceFrom = this.options.inviter
                    params.sourceType = 4
                }
            }

            receiveCourse(params).then(() => {
                this.authSuccess()
            })
        },
        userShareInvitedApi() {
            if (this.options.inviter) {
                userShareInvited({
                    courseId: this.courseId,
                    userId: this.userInfo.id,
                    inviter: this.options.inviter,
                })
            }
        },
        onShowEvaluate() {
            // 检测当前直播进度,直播一小时 显示评价窗口
            const nowTime = +new Date()
            const startTime = +new Date(this.goodsCourseInfo.startTime)
            const showEvaluateState = window.sessionStorage.getItem('showEvaluateState')
            if (nowTime - startTime > 60 * 60 * 1000 && !showEvaluateState) {
                this.isShowEvaluate = true
                window.sessionStorage.setItem('showEvaluateState', true)
            }
        },
        wxSdkReady(course) {
            getWxJsapiTicket().then((res) => {
                const timestamp = parseInt(+new Date() / 1000)
                const nonceStr = randomString(32)
                const signature = sha1(
                    `jsapi_ticket=${res.data.jsapiTicket}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${window.location.href}`
                )
                const wxConfig = {
                    debug: this.options.debug ? true : false,
                    appId: window.WX_APPID,
                    timestamp: timestamp,
                    nonceStr: nonceStr,
                    signature: signature,
                    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
                }
                wxSdk.config(wxConfig)
                const _this = this
                const url = `${window.location.origin}${window.location.pathname}`
                const link = `${url}?courseToken=${this.options.courseToken}&inviter=${this.userInfo.id}&sn=invite`
                wxSdk.ready(function () {
                    wxSdk.updateAppMessageShareData({
                        title: course.title,
                        desc: `${_this.userInfo.nickname}邀请你一起看直播`,
                        link: link,
                        imgUrl: 'https://res.peki.vip/20210520/1621478917137/1621478917135.png',
                    })
                    wxSdk.updateTimelineShareData({
                        title: course.title,
                        link: link,
                        imgUrl: 'https://res.peki.vip/20210520/1621478917137/1621478917135.png',
                    })
                })
            })
        },
        getSubscribeStatusApi() {
            if (!isPekiApp() && !isPekiApplet()) {
                getSubscribeStatus({
                    userId: this.userInfo.id,
                }).then((res) => {
                    if (!res.data || !res.data.status) {
                        this.$refs.officialaccount.onShow()
                    }
                })
            }
        },
    },
}
</script>
<style lang="scss">
.reward-notice {
    position: absolute;
    top: 30px;
    transform: translateX(1000%);
    left: 50%;
    background: rgba($color: #333, $alpha: 0.7);
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    padding: 0 16px;
    height: 30px;
    line-height: 30px;
    z-index: 99;
    white-space: nowrap;
    animation: rewardNotice 5s 0.2s;
    span {
        display: block;
        transform: scale(0.4);
        animation: textAnimaiton 0.4s 0.5s forwards;
    }
}
@keyframes rewardNotice {
    0% {
        transform: translateX(1000%);
    }
    8% {
        transform: translateX(-50%);
    }
    80% {
        transform: translateX(-50%);
    }
    100% {
        transform: translateX(-1000%);
    }
}
@keyframes textAnimaiton {
    60% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
}
.not-start {
    display: flex;
    width: 100%;
    height: 100%;
    background: rgba($color: #999, $alpha: 0.4);
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 999;
    .course-info {
        width: 280px;
        min-height: 140px;
        background: #fff;
        border-radius: 4px;
        text-align: center;
        padding: 20px;
        box-sizing: border-box;
        .title {
            line-height: 24px;
            font-size: 16px;
        }
        .nickname {
            font-size: 14px;
            margin: 16px 0 24px;
        }
        .count-down {
            font-size: 14px;
            line-height: 1.4em;
            span {
                color: #20c6a7;
            }
        }
    }
}
</style>
